import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-lg-500px bg-white rounded shadow-sm p-5 p-lg-5 mx-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, "เข้าสู่ระบบบริการดีพร้อม")
], -1)
const _hoisted_3 = { class: "fv-row mb-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-dark required" }, "Username : เลขบัตรประชาชน 13 หลัก", -1)
const _hoisted_5 = { class: "fv-plugins-message-container" }
const _hoisted_6 = { class: "fv-help-block" }
const _hoisted_7 = { class: "fv-row mb-10" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack mb-2" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 mb-0 required" }, "Password : รหัสผ่าน i.industry")
], -1)
const _hoisted_9 = { class: "fv-plugins-message-container" }
const _hoisted_10 = { class: "fv-help-block" }
const _hoisted_11 = { class: "form-floating d-flex flex-center mb-5" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " เข้าสู่ระบบ ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_19 = { class: "d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_21 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_vue_recaptcha = _resolveComponent("vue-recaptcha")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      class: "form w-100",
      id: "kt_login_signin_form",
      onSubmit: _ctx.onSubmitLogin,
      "validation-schema": _ctx.login
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_Field, {
            class: "form-control form-control-lg form-control-white",
            type: "text",
            name: "username",
            autocomplete: "off",
            placeholder: "username"
          }),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_ErrorMessage, { name: "username" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_Field, {
            class: "form-control form-control-lg form-control-white",
            type: "password",
            name: "password",
            autocomplete: "off",
            placeholder: "password"
          }),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_ErrorMessage, { name: "password" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createVNode(_component_vue_recaptcha, {
            sitekey: _ctx.siteKey,
            size: "normal",
            theme: "light",
            hl: "th",
            onVerify: _ctx.recaptchaVerified,
            onExpire: _ctx.recaptchaExpired,
            onFail: _ctx.recaptchaFailed,
            ref: "vueRecaptcha"
          }, null, 8, ["sitekey", "onVerify", "onExpire", "onFail"]), [
            [_vShow, _ctx.showRecaptcha]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            type: "submit",
            disabled: _ctx.btnLoginDisabled,
            ref: "submitButton",
            id: "kt_sign_in_submit",
            class: "btn btn-lg btn-primary w-100 mb-5"
          }, _hoisted_16, 8, _hoisted_13)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("a", {
            class: "cursor-pointer link-primary fs-6 fw-bolder",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.CheckBeforeSignUp && _ctx.CheckBeforeSignUp(...args)))
          }, "สมัครเข้ารับบริการ (Sign Up)")
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("a", {
            class: "cursor-pointer link-primary fs-6 fw-bolder",
            href: _ctx.iIndustryResetPasswordUrl
          }, "ลืมรหัสผ่าน ?", 8, _hoisted_21)
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}